import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import SVGIcon from '@/components/base/SVGIcon'
import Typography from '@/components/base/Typography'
import TypographyMask from '@/components/base/TypographyMask'

import { bannerRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type BannerProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  text: string
  primary_button: WPLink
  secondary_button: WPLink
}

const Banner = ({ title, text, primary_button, secondary_button, ...props }: BannerProps) => {
  return (
    <Motion animation={bannerRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid>
            <div
              className={cn(
                'col-span-4 md:col-span-6 lg:col-span-12',
                'rounded-[8px] p-spacing-md',
                'flex flex-col gap-spacing-md',
                'bg-gradient-to-r from-[#455D64] to-[#8BB4C0]'
              )}
            >
              <Typography variant="h5" className="font-medium">
                {title}
              </Typography>
              <Typography variant="large" className="font-light">
                {text}
              </Typography>
              <div className={cn('justify-left flex w-full flex-wrap gap-spacing-sm')}>
                {primary_button?.title ? (
                  <Button asChild className="w-full md:w-auto" variant="primary">
                    <Link href={primary_button!.url} target={primary_button?.target}>
                      <TypographyMask>
                        <Typography variant="regular">{primary_button?.title}</Typography>
                      </TypographyMask>
                    </Link>
                  </Button>
                ) : null}
                {secondary_button?.title ? (
                  <Button
                    asChild
                    className="w-full md:w-auto"
                    variant="secondary"
                    endIcon={
                      <SVGIcon
                        className="h-[1.8rem] w-[1.6rem] fill-surface-primary-dark"
                        symbol="arrow-right-2"
                      />
                    }
                  >
                    <Link href={secondary_button!.url} target={secondary_button?.target}>
                      <TypographyMask>
                        <Typography variant="regular">{secondary_button?.title}</Typography>
                      </TypographyMask>
                    </Link>
                  </Button>
                ) : null}
              </div>
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default Banner
